import { IResourceConfig } from '@/Core/Contracts/UI'
import { VehicleFormTemplate } from '../Templates/VehicleFormTemplate'

/** Водії у фільтрі: будь-який статус, крім видаленого — ТЗ може лишатись за деактивованим водієм */
const DRIVER_FILTER_STATUSES = ['invited', 'active', 'inactive']

export const VehicleResource: IResourceConfig = {
    title: 'Транспортні засоби',
    fields: {
        id: {
            label: 'ID',
            type: 'number',
            inputProps: {
                disabled: true,
            },
            /** У фільтрі: оператор (=, >, ≥, <, ≤) або діапазон від–до */
            isFilterRange: true,
        },
        brand: {
            label: 'Марка',
            type: 'string',
            isRequired: true,
        },
        model: {
            label: 'Модель',
            type: 'string',
        },
        modelCode: {
            label: 'Код моделі',
            type: 'string',
        },
        registrationNumber: {
            label: 'Державний номер',
            type: 'string',
            isRequired: true,
        },
        vin: {
            label: 'VIN-код',
            type: 'string',
        },
        /** ID об'єкта у Wialon (пробіг з GPS); водієві в PWA не показується */
        wialonId: {
            label: 'Ідентифікатор Wialon',
            type: 'number',
        },
        yearOfManufacture: {
            label: 'Рік випуску',
            type: 'number',
        },
        weightTariffKg: {
            label: 'Маса (тара), кг',
            type: 'number',
        },
        weightEmptyKg: {
            label: 'Маса без вантажу, кг',
            type: 'number',
        },
        weightWithCargoKg: {
            label: 'Маса з вантажем, кг',
            type: 'number',
        },
        lengthMm: {
            label: 'Довжина, мм',
            type: 'number',
        },
        widthMm: {
            label: 'Ширина, мм',
            type: 'number',
        },
        heightMm: {
            label: 'Висота, мм',
            type: 'number',
        },
        isActive: {
            label: 'Активний',
            type: 'switch',
            defaultValue: true,
        },
        isAutoDecommission: {
            label: 'Автоматичне списання за нормою',
            type: 'switch',
        },
        isAdBlue: {
            label: 'Використання AdBlue',
            type: 'switch',
        },
        isHiredTransport: {
            label: 'Найманий транспорт',
            type: 'switch',
        },
        vehicleType: {
            label: 'Тип ТЗ',
            type: 'select',
            /** У фільтрі — кілька значень (<поле>.uuid in […]) */
            isFilterMultiple: true,
            resource: 'Setting.ListVehicleType',
            inputProps: {
                filter: {
                    isActive: true,
                },
            },
        },
        vehicleKind: {
            label: 'Вид ТЗ',
            type: 'select',
            /** У фільтрі — кілька значень (<поле>.uuid in […]) */
            isFilterMultiple: true,
            resource: 'Setting.ListVehicleKind',
            inputProps: {
                filter: {
                    isActive: true,
                },
            },
        },
        carrier: {
            label: 'Перевізник',
            type: 'select',
            /** У фільтрі — кілька значень (<поле>.uuid in […]) */
            isFilterMultiple: true,
            resource: 'Setting.ListCarrier',
            inputProps: {
                filter: {
                    isActive: true,
                },
            },
        },
        trailer: {
            label: 'Причіп',
            type: 'select',
            resource: 'Transport.Vehicle',
            inputProps: {
                filter: {
                    isActive: true,
                    // TODO: add filter by vehicle type when it will be implemented in backend
                    'vehicleType.code': 'trailer',
                },
            },
            responseLabel: (value) => `${value?.brand} ${value?.model} ${value?.registrationNumber}`,
        },
        driver: {
            label: 'Водій',
            type: 'select',
            resource: 'Setting.User',
            inputProps: {
                filter: {
                    type: 'DRIVER',
                    status: 'active',
                },
            },
            /** У фільтрі — кілька водіїв (driver.uuid in […]) */
            isFilterMultiple: true,
            /** Опції фільтра: водії будь-якого статусу, крім видаленого (у формі — лише активні) */
            filterOptionsFilter: {
                type: 'DRIVER',
                status: DRIVER_FILTER_STATUSES,
            },
        },
        externalCode: {
            label: 'Унікальний код ERP',
            type: 'string',
        },
        sorting: {
            label: 'Сортування',
            type: 'number',
        },
    },
    filter: {
        includeFields: [
            'id',
            'registrationNumber',
            'model',
            'brand',
            'driver',
            'isActive',
            'vehicleType',
            'vehicleKind',
            'carrier',
            'isAdBlue',
            'isAutoDecommission',
            'isHiredTransport',
            'externalCode',
        ],
    },
    table: {
        showColumns: [
            'brand',
            'model',
            'registrationNumber',
            'wialonId',
            'weightEmptyKg',
            'weightWithCargoKg',
            'isActive',
            'isHiredTransport',
            'vehicleType',
            'vehicleKind',
            'carrier',
            'driver',
            'sorting',
        ],
        scroll: { x: 'max-content' },
        eventHandlers: {
            onBuildColumn: {
                setColumnWidths: ({ column }: any) => {
                    const widths: Record<string, number> = {
                        id: 40,
                        modelCode: 120,
                        registrationNumber: 100,
                        wialonId: 110,
                        weightEmptyKg: 100,
                        weightWithCargoKg: 110,
                        isHiredTransport: 100,
                    }
                    if (widths[column.dataIndex]) {
                        column.width = widths[column.dataIndex]
                    }
                },
            },
        },
    },
    restUrl: '/services/vehicles',
    pageUrl: '/transport/vehicles',
    form: {
        template: VehicleFormTemplate,
    },
    settings: {
        searchFields: ['id', 'registrationNumber', 'brand', 'model', 'wialonId'],
    },
}
